const queryParamsRemoval = (urlName: string | undefined) =>
  urlName?.split?.('?')?.[0]

export { queryParamsRemoval }
